module.exports = __webpack_public_path__ + "static/woman_smilling-736cd875cba2cdf54b08262ef3db4f21.png";